import { reducerRegistry } from 'reducer-registry'

const { createSlice } = require('@reduxjs/toolkit')

const initialState = {
  floatingButtonVisible: false
}

const slice = createSlice({
  name: 'userGuide',
  initialState,
  reducers: {
    setFloatingButtonVisible: (state, { payload }) => {
      state.floatingButtonVisible = payload
    },
  }
})

reducerRegistry.add('userGuide', slice.reducer)

export const {
  actions: {
    setFloatingButtonVisible
  }
} = slice

export const isFloatingButtonVisibleSelector = (state) => state.userGuide.floatingButtonVisible
